<a mat-icon-button class="xsmall-button" (click)="openDialog()" matTooltip="{{'general.edit' | transloco}}">
    <mat-icon>edit</mat-icon>
</a>

<ng-template let-modal #editNodeModal>
    <div mat-dialog-content>
        <mat-form-field class="form-element">
            <mat-label>{{'general.name' | transloco}}</mat-label>
            <input matInput type="text" class="form-control" inputrestriction="basic2"
                   placeholder="{{'general.name' | transloco}}" [(ngModel)]="name" autocomplete="off"/>
        </mat-form-field>
        <br/>
        <div mat-dialog-actions style="justify-content: center;">
            <button mat-button color="warn" (click)="onNoClick()" style="position: relative;right: 15px;">
                {{'general.cancel' | transloco}}
            </button>
            <button mat-raised-button (click)="onAdd()" [disabled]="!name || name === currentNode?.Name">
                {{'general.update' | transloco}}
            </button>
        </div>
        <br/>
    </div>
</ng-template>
